import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './shared/theme/global.css';

// Limpieza agresiva de Service Workers antiguos (Expo Web PWA)
// Evita que los usuarios vean versiones cacheadas y desactualizadas del sitio.
// NOTA: Usamos void IIFE (no top-level await) porque el target de Vite es es2020,
// que no soporta top-level await fuera de módulos nativos.
if ('serviceWorker' in navigator) {
  // eslint-disable-next-line unicorn/prefer-top-level-await
  void (async () => {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      await registration.unregister();
      console.log('[Cache] Service Worker antiguo purgado con éxito.');
    }
  })();
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
